import type { Phrase } from '../types';

/**
 * Shared strings for the public site: navigation, footer, the venue card, the
 * event types and the six occasion groups. Page-specific strings live in the
 * sibling files (home, explore, venue, booking, pages).
 */
export const coreEn = {
  // navigation
  snHome: 'Home',
  snExplore: 'Explore venues',
  snEventTypes: 'Event types',
  snLocations: 'Locations',
  snInspiration: 'Inspiration',
  snAbout: 'About us',
  snListVenue: 'List your venue',
  snLogin: 'Log in',
  snBook: 'Book a venue',
  snSkip: 'Skip to content',

  // full-screen menu (header button on desktop, the floating dock on phones)
  mmMenu: 'Menu',
  mmClose: 'Close',
  mmHomeSub: 'Search and featured venues',
  mmExploreSub: { one: '{count} venue', other: '{count} venues' },
  mmExploreSubNone: 'All venues',
  mmEventsSub: { one: '{count} occasion', other: '{count} occasions' },
  mmLocationsSub: '{cities} & more',
  mmLocationsSubNone: 'Venues by city',
  mmInspirationSub: 'Guides & ideas',
  mmAboutSub: 'How Aghosha works',
  mmSpotlight: 'Venue spotlight',
  mmOccasions: 'Browse by occasion',
  mmReady: 'Ready when you are',
  mmTalk: 'Talk to us',
  mmMyBookings: 'My bookings',

  // footer
  ftTagline: 'Find auditoriums and event venues for weddings, conferences and celebrations, compare them and send a booking request.',
  ftExplore: 'Explore',
  ftAllVenues: 'All venues',
  ftLocations: 'Popular locations',
  ftResources: 'Plan your event',
  ftCompany: 'Company',
  ftAbout: 'About Aghosha',
  ftContact: 'Contact us',
  ftPrivacy: 'Privacy policy',
  ftHowItWorks: 'How booking works',
  ftGuides: 'Planning guides',
  ftFaq: 'Questions and answers',
  ftPlanTitle: 'Planning something big?',
  ftPlanBody: 'Tell us the date, the guest count and the kind of event. We will help you find the right venue.',
  ftPlanCta: 'Talk to us',
  ftMadeIn: 'Made in Kerala, for every celebration.',
  ftBrandLineA: 'Find the space.',
  ftBrandLineB: 'Make the moment.',
  ftAddress: 'Address',
  ftContactLabel: 'Contact',

  // venue card
  vcFrom: 'From',
  vcView: 'View venue',
  vcGuests: '{count} guests',
  vcRooms: { one: '{count} room', other: '{count} rooms' },
  vcSave: 'Save {name}',
  vcUnsave: 'Remove {name} from saved',
  priceUnitHour: '/ hour',
  priceUnitHalfDay: '/ session',
  priceUnitDay: '/ day',

  // event types (stored values in content/occasions.ts)
  evWedding: 'Wedding',
  evEngagement: 'Engagement',
  evReception: 'Reception',
  evBirthday: 'Birthday',
  evConference: 'Conference',
  evSeminar: 'Seminar',
  evWorkshop: 'Workshop',
  evCultural: 'Cultural programme',
  evMusic: 'Music event',
  evCorporate: 'Corporate meeting',
  evLaunch: 'Product launch',
  evReligious: 'Religious function',
  evOther: 'Other event',

  // the six occasion groups
  occWeddings: 'Weddings',
  occWeddingsBody: 'Elegant halls for the ceremony, the reception and everyone who comes.',
  occConferences: 'Conferences',
  occConferencesBody: 'Stages, screens and seating for meetings that need to run on time.',
  occSeminars: 'Seminars & workshops',
  occSeminarsBody: 'Comfortable rooms for talks, training and learning together.',
  occCultural: 'Cultural events',
  occCulturalBody: 'Auditoriums made for performances, programmes and community nights.',
  occCelebrations: 'Parties & celebrations',
  occCelebrationsBody: 'Birthdays, anniversaries and family get-togethers with room to celebrate.',
  occCorporate: 'Corporate events',
  occCorporateBody: 'Launches, town halls and company days, handled professionally.',
} satisfies Record<string, Phrase>;
